module.exports = __webpack_public_path__ + "static/img/qmb1-life_privileges_bg.dad27d07.png";